export function isEmployeeAccessRole( selectedRole: string | null | undefined
): boolean { return (selectedRole ?? "Employee").toLowerCase() === "employee";}